import React, { useContext, useEffect } from "react";

import { Form } from "react-bootstrap";
import { MainContext } from "../../Context/MainContext";

const DesktopSortContainer = () => {
  const { MainState, handleSortSelect } = useContext(MainContext);
  const { useMazdaBranding } = MainState;
  const sortOptions = MainState.sortOptions;
  const sortValue = MainState.sortValue;
  // sortValue may be a "field_dir,field_dir" chain (see MainContext's sortSpecials) when set
  // via a share-link URL. The dropdown only ever offers single-field options, so reflect just
  // the primary field here — the rest is a tiebreaker the UI was never meant to expose.
  const primarySortValue = sortValue.split(",")[0];

  const handleChange = (e) => {
    handleSortSelect(e.target.value);
  };

  // Initialize sort value
  useEffect(() => {
    handleSortSelect(sortValue);
  }, []);

  return (
    <div className="form-inline">
      <Form.Group controlId="sortResults">
        <Form.Label className={`mr-2 ${useMazdaBranding ? "text-mazda" : "text-blue-600"} text-sm font-weight-bold`}>
          Sort by:
        </Form.Label>
        <Form.Control
          className="border-slate-500"
          value={primarySortValue}
          onChange={handleChange}
          as="select"
          custom
        >
          <option value="" disabled>
            -- Sort Specials --
          </option>
          {sortOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </Form.Control>
      </Form.Group>
    </div>
  );
};

export default DesktopSortContainer;
